import { AfterViewInit, ContentChildren, Directive, inject, OnDestroy, Output, QueryList } from '@angular/core';
import { NavigationEnd, Router, RouterLinkActive } from '@angular/router';
import { BehaviorSubject, delay, filter, startWith, Subscription, tap } from 'rxjs';

@Directive({
    selector: '[appRouterLinkActiveTrigger]',
})
export class RouterLinkActiveTriggerDirective implements AfterViewInit, OnDestroy {
    @Output() active = new BehaviorSubject<boolean>(false);
    @ContentChildren(RouterLinkActive, { descendants: true }) links: QueryList<RouterLinkActive>;

    private readonly router = inject(Router);
    private readonly subscriptions$ = new Subscription();

    ngAfterViewInit(): void {
        this.subscriptions$.add(
            this.router.events
                .pipe(
                    filter((event) => event instanceof NavigationEnd),
                    startWith(''),
                    delay(10),
                    tap(() => this.active.next(this.links.some((link) => link.isActive))),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
